
// import React, { useState, useEffect } from "react";
// import SimilarProduct from "./SimilarProduct";
// import { globalStore } from "stores/globalStore";
// import service from "services/service";
// import { useNavigate, useParams } from "react-router-dom";
// import { Button, message, Spin } from "antd";
// import Cart from "../assets/Images/img_cart.svg";
// import Freeshipping from "../../src/assets/Images/free-shippin.svg fill.png";
// import Return from "../../src/assets/Images/return.png";

// const ProductView = () => {
//   const authToken = localStorage.getItem("authToken");

//   const [loadings, setLoadings] = useState(false);
//   const [pageLoading, setPageLoading] = useState(true);
//   const [quantity, setQuantity] = useState(1);
//   const [primaryImage, setPrimaryImage] = useState(null);
//   const [pincode, setPincode] = useState("");
//   const [isSizeExpanded, setIsSizeExpanded] = useState(false);
//   const [productData, setProductData] = useState(null);
//   const [selectedColor, setSelectedColor] = useState(null);
//   const [selectedSize, setSelectedSize] = useState(null);
//   const { id } = useParams();
  
//   const {
//     productDetailsPageData,
//     setCartCount,
//     setProductDetailsPageData,
//     cartCount,
//     pinCodeData,
//     setPinCodeData,
//   } = globalStore();

//   const navigate = useNavigate();

//   // Fetch product details when component mounts
//   useEffect(() => {
//     const fetchProductDetails = async () => {
//       if (!id) {
//         setPageLoading(false);
//         return;
//       }

//       if (productDetailsPageData?.productDetails?._id === id) {
//         setProductData(productDetailsPageData.productDetails);
//         setPrimaryImage(productDetailsPageData.productDetails.primaryImage);
//         setPageLoading(false);
//         return;
//       }

//       setPageLoading(true);
//       try {
//         const response = await service.getProductDetailsById(id);
//         if (response.data.meta?.status || response.data.data) {
//           const product = response.data.data;
//           setProductData(product);
//           setPrimaryImage(product.primaryImage);
//           setProductDetailsPageData({
//             productDetails: product
//           });
//         } else {
//           message.error("Failed to fetch product details");
//         }
//       } catch (error) {
//         console.error("Error fetching product details:", error);
//         message.error("Error loading product details");
//       } finally {
//         setPageLoading(false);
//       }
//     };

//     fetchProductDetails();
//   }, [id, productDetailsPageData, setProductDetailsPageData]);

//   const currentProduct = productData || productDetailsPageData?.productDetails;

//   useEffect(() => {
//     if (currentProduct?.primaryImage) {
//       setPrimaryImage(currentProduct.primaryImage);
//     }
//   }, [currentProduct]);

//   const handleColorSelect = (color) => {
//     setSelectedColor(color);
//     console.log("Selected color:", color);
//   };

//   const handleSizeSelect = (size) => {
//     setSelectedSize(size);
//     console.log("Selected size:", size);
//   };

//   const handleSecondaryImageClick = (image) => {
//     setPrimaryImage(image);
//   };

//   const handleAddToCart = async () => {
//     try {
//       if (!selectedColor) {
//         message.error("Please select a color before adding to cart.");
//         return;
//       }
      
//       if (!selectedSize) {
//         message.error("Please select a size before adding to cart.");
//         return;
//       }
      
//       setLoadings(true);

//       // Clean and validate data
//       const cleanProductId = String(id).trim();
//       const cleanColor = String(selectedColor).trim();
//       const cleanSize = String(selectedSize).trim();

//       const customProductPayload = {
//         product: cleanProductId,
//         fontColor: cleanColor,
//         tShirtSize: cleanSize,
//       };

//       console.log("=== Sending to Backend ===");
//       console.log("Payload:", JSON.stringify(customProductPayload, null, 2));
//       console.log("Auth Token exists:", !!authToken);

//       const createCustomProductResponse = await service.customCreateCart(customProductPayload);
      
//       console.log("Response received:", createCustomProductResponse);

//       const createdProduct = createCustomProductResponse?.data?.data?._id;

//       if (createdProduct) {
//         const cartPayload = {
//           items: [
//             {
//               customTShirtPrint: createdProduct,
//               quantity: quantity,
//             },
//           ],
//         };

//         await service.createCart(cartPayload);
//         setCartCount(cartCount + 1);
//         message.success("Item added to cart successfully!");

//         setSelectedColor(null);
//         setSelectedSize(null);
//         setPrimaryImage(currentProduct?.primaryImage || null);
//         setQuantity(1);
//       } else {
//         message.error(createCustomProductResponse?.data?.meta?.message || "Failed to create custom product. Please try again.");
//       }
//     } catch (error) {
//       console.error("=== Error Details ===");
//       console.error("Error object:", error);
//       console.error("Error response:", error.response);
//       console.error("Error response data:", error.response?.data);
//       console.error("Error status:", error.response?.status);
      
//       if (authToken === null) {
//         navigate("/signup");
//       } else {
//         const errorMessage = error.response?.data?.meta?.message || error.message || "An error occurred";
//         message.error(errorMessage);
//       }
//     } finally {
//       setLoadings(false);
//     }
//   };

//   const handleBuyNow = async () => {
//     try {
//       if (!selectedColor) {
//         message.error("Please select a color before proceeding.");
//         return;
//       }
      
//       if (!selectedSize) {
//         message.error("Please select a size before proceeding.");
//         return;
//       }
      
//       setLoadings(true);

//       const customProductPayload = {
//         product: String(id).trim(),
//         fontColor: String(selectedColor).trim(),
//         tShirtSize: String(selectedSize).trim(),
//       };

//       console.log("Buy Now Payload:", JSON.stringify(customProductPayload, null, 2));

//       const createCustomProductResponse = await service.customCreateCart(customProductPayload);
//       const createdProduct = createCustomProductResponse?.data?.data?._id;

//       if (createdProduct) {
//         const buyNowPayload = {
//           items: [
//             {
//               customTShirtPrint: createdProduct,
//               quantity: quantity,
//             },
//           ],
//         };

//         const createOrderResponse = await service.createCart(buyNowPayload);
//         const cartData = createOrderResponse?.data?.data?.items;
//         const totalCart = createOrderResponse?.data?.data;

//         if (cartData && totalCart) {
//           message.success("Redirecting to cart...");
//           navigate("/cart", { state: { cartData, totalCart } });
//         } else {
//           throw new Error("Failed to retrieve cart data.");
//         }
//       } else {
//         throw new Error("Failed to create custom product.");
//       }
//     } catch (error) {
//       console.error("Error in handleBuyNow:", error);

//       if (authToken === null) {
//         navigate("/signup");
//       } else {
//         message.error(
//           error.response?.data?.meta?.message || "This custom T-shirt print design already exists for this product"
//         );
//       }
//     } finally {
//       setLoadings(false);
//     }
//   };

//   const handlePincodeCheck = async () => {
//     if (!pincode || pincode.length !== 6) {
//       message.error("Please enter a valid 6-digit pincode");
//       return;
//     }
//     try {
//       const response = await service.pinChackService({
//         deliveryPinCode: pincode,
//       });
//       setPinCodeData(response.data);
//     } catch (error) {
//       console.log(error);
//       message.error("Failed to check pincode. Please try again.");
//     }
//   };

//   if (pageLoading) {
//     return (
//       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
//         <Spin size="large" />
//       </div>
//     );
//   }

//   if (!currentProduct) {
//     return (
//       <div style={{ textAlign: 'center', padding: '50px' }}>
//         <h2>Product not found</h2>
//         <Button onClick={() => navigate('/')}>Go Back Home</Button>
//       </div>
//     );
//   }

//   return (
//     <>
//       <div className="column_one">
//         <div className="product-detail-1">
//           <div className="product-detail__brand-section">
//             <div className="product-detail__images">
//               <div className="product-detail__image-list">
//                 {currentProduct?.secondaryImages?.map(
//                   (image, index) => (
//                     <img
//                       key={index}
//                       src={image}
//                       alt={`Secondary Image ${index + 1}`}
//                       className="secondary-image"
//                       onClick={() => handleSecondaryImageClick(image)}
//                     />
//                   )
//                 )}
//               </div>
//               <div>
//                 <img
//                   src={primaryImage}
//                   alt="Main Image"
//                   className="product-detail__image--main"
//                 />
//               </div>
//             </div>
//             <div className="product-detail__details">
//               <p className="product-detail__brand ui text size-text3xl">
//                 {currentProduct?.name}
//               </p>
//               <p className="product-detail__title ui text size-text4xl">
//                 {currentProduct?.description}
//               </p>
//               <div className="product-detail__price-section">
//                 <p className="product-detail__price ui text size-text3xl">
//                   ₹ {currentProduct?.discountPrice}
//                 </p>
//                 <p className="product-detail__price--old ui text size-text3xl">
//                   ₹ {currentProduct?.price}
//                 </p>
//                 {currentProduct?.discount && (
//                   <p className="product-detail__discount ui text size-textmd">
//                     ({currentProduct.discount} OFF)
//                   </p>
//                 )}
//               </div>
//               <div className="product-detail__attributes">
//                 <div className="product-detail__attribute">
//                   <div className="product-detail__attribute-color">
//                     <p className="product-detail__color-label ui text size-textxl">
//                       Color:
//                     </p>
//                     <div className="product-detail__color-value-container">
//                       {selectedColor && (
//                         <div 
//                           className="selected-color-indicator"
//                           style={{ 
//                             backgroundColor: selectedColor,
//                             width: '30px',
//                             height: '30px',
//                             borderRadius: '4px',
//                             border: '1px solid #ddd'
//                           }}
//                         />
//                       )}
//                     </div>
//                   </div>
//                   <div className="product-detail__swatches">
//                     {currentProduct?.color?.map(
//                       (color, index) => (
//                         <div
//                           key={index}
//                           className={`product-detail__swatch-item ${
//                             selectedColor === color
//                               ? "product-detail__swatch--selected"
//                               : ""
//                           }`}
//                           onClick={() => handleColorSelect(color)}
//                           style={{ cursor: 'pointer' }}
//                         >
//                           <div
//                             className="product-detail__swatch-background"
//                             style={{ background: color, width: '40px', height: '40px', borderRadius: '50%', margin: '5px', border: selectedColor === color ? '2px solid #700ee8' : '1px solid #ddd' }}
//                           ></div>
//                         </div>
//                       )
//                     )}
//                   </div>
//                 </div>
//                 <div className="product-detail__sizes">
//                   <div className="product-detail__size-container">
//                     <p className="product-detail__size-label ui text size-textxl">
//                       Size:
//                     </p>
//                   </div>
//                   <div className="product-detail__size-options">
//                     {currentProduct?.size?.map(
//                       (size, index) => (
//                         <div
//                           key={index}
//                           className={`product-detail__size-option ${
//                             selectedSize === size ? "selected" : ""
//                           }`}
//                           onClick={() => handleSizeSelect(size)}
//                           style={{ 
//                             cursor: 'pointer', 
//                             padding: '10px 20px', 
//                             border: selectedSize === size ? '2px solid #700ee8' : '1px solid #ddd',
//                             margin: '5px',
//                             display: 'inline-block',
//                             backgroundColor: selectedSize === size ? '#700ee8' : 'transparent',
//                             color: selectedSize === size ? 'white' : 'black',
//                             borderRadius: '4px'
//                           }}
//                         >
//                           {size}
//                         </div>
//                       )
//                     )}
//                   </div>
//                 </div>
//               </div>

//               <div className="product-detail__quantity">
//                 <label>Quantity:</label>
//                 <input
//                   type="number"
//                   min="1"
//                   value={quantity}
//                   onChange={(e) => setQuantity(parseInt(e.target.value))}
//                   className="quantity-input"
//                   style={{ marginLeft: '10px', padding: '5px', width: '60px' }}
//                 />
//               </div>

//               <div className="product-detail__actions">
//                 <Button
//                   className="flex-row-center-center product-detail__add-to-cart-button ui button black_900_01 size-xl fill round"
//                   onClick={handleAddToCart}
//                   loading={loadings}
//                 >
//                   <img src={Cart} alt="Cart" className="cart" />
//                   <span>Add to Cart</span>
//                 </Button>
//                 <Button
//                   onClick={handleBuyNow}
//                   className="flex-row-center-center product-detail__add-to-cart-button ui button deep_orange_700 size-xl fill round"
//                   loading={loadings}
//                 >
//                   Buy Now
//                 </Button>
//               </div>
//               <div className="product-detail__delivery">
//                 <div className="product-detail__delivery-check">
//                   <p className="product-detail__delivery-label ui text size-textxl">
//                     Check delivery date
//                   </p>
//                 </div>
//                 <div className="product-detail__pincode-section">
//                   <label className="product-detail__pincode-input ui input size-xs square">
//                     <input
//                       onChange={(e) => setPincode(e.target.value)}
//                       name="Pincode Input"
//                       placeholder="Enter Your city Pincode"
//                       type="number"
//                     />
//                   </label>
//                   <button
//                     onClick={handlePincodeCheck}
//                     className="flex-row-center-center product-detail__pincode-check-button ui button black_900_01 size-md fill"
//                   >
//                     Check
//                   </button>
//                 </div>

//                 {pinCodeData && pinCodeData.length > 0 && (
//                   <div className="pincode-data-section">
//                     <div className="pincode-data-item">
//                       <p className="ui text size-textmd">
//                         <span className="courier">Courier:</span>{" "}
//                         {pinCodeData[1]?.courier_name}
//                       </p>
//                       <p className="ui text size-textmd">
//                         <span className="courier"> Estimated Delivery: </span>{" "}
//                         {pinCodeData[0]?.etd} ({pinCodeData[0]?.etd_hours} hours)
//                       </p>
//                     </div>
//                   </div>
//                 )}

//                 <div className="product-detail__shipping-info">
//                   <div className="product-detail__shipping-container">
//                     <img
//                       src={Freeshipping}
//                       alt="Free Shipping Icon"
//                       className="product-detail__shipping-icon"
//                     />
//                     <p className="product-detail__shipping-label ui text size-textmd">
//                       Free Shipping
//                     </p>
//                   </div>
//                   <div className="product-detail__shipping-container">
//                     <img
//                       src={Return}
//                       alt="Return Icon"
//                       className="product-detail__shipping-icon"
//                     />
//                     <p className="product-detail__shipping-label ui text size-textmd">
//                       7 Days return & exchange
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <SimilarProduct />
//       </div>
//     </>
//   );
// };

// export default ProductView;
import React, { useState, useEffect } from "react";
import { globalStore } from "stores/globalStore";
import service from "services/service";
import { useNavigate, useParams } from "react-router-dom";
import { Button, message, Spin, Modal, Input, Skeleton } from "antd";
import { ShoppingCartOutlined, ThunderboltOutlined, CheckOutlined, CloseOutlined, EnvironmentOutlined, TruckOutlined, ReloadOutlined } from "@ant-design/icons";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { toast } from "react-toastify";
import Cart from "../assets/Images/img_cart.svg";
import Freeshipping from "../../src/assets/Images/free-shippin.svg fill.png";
import Return from "../../src/assets/Images/return.png";
import "./ProductView.css"; // We'll create this CSS file

const ProductView = () => {
  const authToken = localStorage.getItem("authToken");

  const [loadings, setLoadings] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [quantity, setQuantity] = useState(1);
  const [primaryImage, setPrimaryImage] = useState(null);
  const [pincode, setPincode] = useState("");
  const [isSizeExpanded, setIsSizeExpanded] = useState(false);
  const [productData, setProductData] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [isPincodeModalVisible, setIsPincodeModalVisible] = useState(false);
  const [pincodeLoading, setPincodeLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);
  const [isWishlisted, setIsWishlisted] = useState(false);
  const { id } = useParams();
  
  const {
    productDetailsPageData,
    setCartCount,
    setProductDetailsPageData,
    cartCount,
    pinCodeData,
    setPinCodeData,
  } = globalStore();

  const navigate = useNavigate();

  // Fetch product details when component mounts
  useEffect(() => {
    const fetchProductDetails = async () => {
      if (!id) {
        setPageLoading(false);
        return;
      }

      if (productDetailsPageData?.productDetails?._id === id) {
        setProductData(productDetailsPageData.productDetails);
        setPrimaryImage(productDetailsPageData.productDetails.primaryImage);
        setPageLoading(false);
        return;
      }

      setPageLoading(true);
      try {
        const response = await service.getProductDetailsById(id);
        if (response.data.meta?.status || response.data.data) {
          const product = response.data.data;
          setProductData(product);
          setPrimaryImage(product.primaryImage);
          setProductDetailsPageData({
            productDetails: product
          });
        } else {
          message.error("Failed to fetch product details");
        }
      } catch (error) {
        console.error("Error fetching product details:", error);
        message.error("Error loading product details");
      } finally {
        setPageLoading(false);
      }
    };

    fetchProductDetails();
  }, [id, productDetailsPageData, setProductDetailsPageData]);

  useEffect(() => {
    const checkWishlist = async () => {
      try {
        // {"items":[{"product":"69da011aca71f7a3c59b7a2c","tShirtSize":"XL"}]}
          const payload = { items: [{"product":id}] };
              // const response = await Service.addOrUpdateWishlistService(payload);
        const res = await service.addOrUpdateWishlistService(payload);
        const ids = (res.data || []).map((item) => item.productId?._id || item.productId);
        setIsWishlisted(ids.includes(id));
      } catch {}
    };
    if (id) checkWishlist();
  }, [id]);

  const currentProduct = productData || productDetailsPageData?.productDetails;

  useEffect(() => {
    if (currentProduct?.primaryImage) {
      setPrimaryImage(currentProduct.primaryImage);
    }
  }, [currentProduct]);

  const handleColorSelect = (color) => {
    setSelectedColor(color);
  };

  const handleSizeSelect = (size) => {
    setSelectedSize(size);
    setIsSizeExpanded(false);
  };

  const toggleWishlist = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      toast.info("Please login to add to wishlist");
      navigate("/login");
      return;
    }
    try {
      if (isWishlisted) {
        await service.removeWishlistService({ productId: id });
        setIsWishlisted(false);
        toast.success("Removed from wishlist");
      } else {
        // await service.addOrUpdateWishlistService({ productId: id });
                const payload = { items: [{"product":id}] };
                await service.addOrUpdateWishlistService(payload);
        setIsWishlisted(true);
        toast.success("Added to wishlist");
      }
    } catch {
      toast.error("Something went wrong");
    }
  };

  const handleSecondaryImageClick = (image) => {
    setImageLoading(true);
    setPrimaryImage(image);
  };

  const validateSelections = () => {
    if (!selectedColor) {
      message.error("Please select a color before adding to cart.");
      return false;
    }
    if (!selectedSize) {
      message.error("Please select a size before adding to cart.");
      return false;
    }
    return true;
  };

  const handleAddToCart = async () => {
    if (!validateSelections()) return;
    
    setLoadings(true);
    try {
      const cleanProductId = String(id).trim();
      const cleanColor = String(selectedColor).trim();
      const cleanSize = String(selectedSize).trim();

      const customProductPayload = {
        product: cleanProductId,
        fontColor: cleanColor,
        tShirtSize: cleanSize,
      };

      const createCustomProductResponse = await service.customCreateCart(customProductPayload);
      const createdProduct = createCustomProductResponse?.data?.data?._id;

      if (createdProduct) {
        const cartPayload = {
          items: [
            {
              customTShirtPrint: createdProduct,
              quantity: quantity,
            },
          ],
        };

        await service.createCart(cartPayload);
        setCartCount(cartCount + 1);
        message.success({
          content: "Item added to cart successfully!",
          icon: <CheckOutlined />,
          duration: 2,
        });

        // Reset selections
        setSelectedColor(null);
        setSelectedSize(null);
        setPrimaryImage(currentProduct?.primaryImage || null);
        setQuantity(1);
      } else {
        message.error("Failed to create custom product. Please try again.");
      }
    } catch (error) {
      console.error("Error in handleAddToCart:", error);
      
      if (authToken === null) {
        Modal.confirm({
          title: "Login Required",
          content: "Please login to add items to your cart",
          okText: "Login Now",
          cancelText: "Cancel",
          onOk: () => navigate("/signup"),
        });
      } else {
        const errorMessage = error.response?.data?.meta?.message || "An error occurred while adding to cart";
        message.error(errorMessage);
      }
    } finally {
      setLoadings(false);
    }
  };

  const handleBuyNow = async () => {
    if (!validateSelections()) return;
    
    setLoadings(true);
    try {
      const customProductPayload = {
        product: String(id).trim(),
        fontColor: String(selectedColor).trim(),
        tShirtSize: String(selectedSize).trim(),
      };

      const createCustomProductResponse = await service.customCreateCart(customProductPayload);
      const createdProduct = createCustomProductResponse?.data?.data?._id;

      if (createdProduct) {
        const buyNowPayload = {
          items: [
            {
              customTShirtPrint: createdProduct,
              quantity: quantity,
            },
          ],
        };

        const createOrderResponse = await service.createCart(buyNowPayload);
        const cartData = createOrderResponse?.data?.data?.items;
        const totalCart = createOrderResponse?.data?.data;

        if (cartData && totalCart) {
          message.success("Redirecting to cart...");
          navigate("/cart", { state: { cartData, totalCart } });
        } else {
          throw new Error("Failed to retrieve cart data.");
        }
      } else {
        throw new Error("Failed to create custom product.");
      }
    } catch (error) {
      console.error("Error in handleBuyNow:", error);

      if (authToken === null) {
        Modal.confirm({
          title: "Login Required",
          content: "Please login to proceed with purchase",
          okText: "Login Now",
          cancelText: "Cancel",
          onOk: () => navigate("/signup"),
        });
      } else {
        message.error(
          error.response?.data?.meta?.message || "Unable to process. Please try again."
        );
      }
    } finally {
      setLoadings(false);
    }
  };

  const handlePincodeCheck = async () => {
    if (!pincode || pincode.length !== 6) {
      message.error("Please enter a valid 6-digit pincode");
      return;
    }
    
    setPincodeLoading(true);
    try {
      const response = await service.pinChackService({
        deliveryPinCode: pincode,
      });
      setPinCodeData(response.data);
      message.success("Delivery available to your location!");
      setIsPincodeModalVisible(false);
    } catch (error) {
      console.log(error);
      message.error("Delivery not available for this pincode");
    } finally {
      setPincodeLoading(false);
    }
  };

  const incrementQuantity = () => {
    if (quantity < 10) {
      setQuantity(prev => prev + 1);
    } else {
      message.warning("Maximum quantity limit is 10");
    }
  };

  const decrementQuantity = () => {
    if (quantity > 1) {
      setQuantity(prev => prev - 1);
    }
  };

  if (pageLoading) {
    return (
      <div className="product-loading-container">
        <Spin size="large" />
      </div>
    );
  }

  if (!currentProduct) {
    return (
      <div className="product-not-found">
        <div className="not-found-content">
          <div className="not-found-icon">🛍️</div>
          <h2>Product not found</h2>
          <p>The product you're looking for doesn't exist or has been removed.</p>
          <Button type="primary" onClick={() => navigate('/')}>
            Continue Shopping
          </Button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="product-view-container">
        <div className="product-view-wrapper">
          {/* Product Images Section */}
          <div className="product-images-section">
            <div className="thumbnail-list">
              {currentProduct?.secondaryImages?.map((image, index) => (
                <div
                  key={index}
                  className={`thumbnail-item ${primaryImage === image ? 'active' : ''}`}
                  onClick={() => handleSecondaryImageClick(image)}
                >
                  <img src={image} alt={`Thumbnail ${index + 1}`} />
                </div>
              ))}
            </div>
            <div className="main-image-container">
              {imageLoading && <div className="image-loader"><Spin /></div>}
              <img
                src={primaryImage}
                alt={currentProduct?.name}
                className="main-image"
                onLoad={() => setImageLoading(false)}
                style={{ display: imageLoading ? 'none' : 'block' }}
              />
              <button
                className="wishlist-heart-btn detail-page"
                onClick={toggleWishlist}
                aria-label="Toggle wishlist"
              >
                {isWishlisted ? (
                  <FaHeart className="heart-icon filled" />
                ) : (
                  <FaRegHeart className="heart-icon" />
                )}
              </button>
            </div>
          </div>

          {/* Product Details Section */}
          <div className="product-details-section">
            <div className="product-header">
              <h1 className="product-name">{currentProduct?.name}</h1>
              <div className="product-price-wrapper">
                <span className="discount-price">₹{currentProduct?.discountPrice}</span>
                <span className="original-price">₹{currentProduct?.price}</span>
                {currentProduct?.discount && (
                  <span className="discount-badge">{currentProduct.discount} OFF</span>
                )}
              </div>
            </div>

            <div className="product-description">
              <p>{currentProduct?.description}</p>
            </div>

            {/* Color Selection */}
            <div className="selection-section">
              <div className="section-header">
                <span className="section-title">Color</span>
                {selectedColor && (
                  <span className="selected-value">
                    Selected: <span style={{ backgroundColor: selectedColor, display: 'inline-block', width: '16px', height: '16px', borderRadius: '50%', verticalAlign: 'middle', marginLeft: '5px' }}></span>
                  </span>
                )}
              </div>
              <div className="color-options">
                {currentProduct?.color?.map((color, index) => (
                  <div
                    key={index}
                    className={`color-option ${selectedColor === color ? 'selected' : ''}`}
                    onClick={() => handleColorSelect(color)}
                  >
                    <div className="color-swatch" style={{ backgroundColor: color }}></div>
                    {selectedColor === color && <CheckOutlined className="selected-icon" />}
                  </div>
                ))}
              </div>
            </div>

            {/* Size Selection */}
            <div className="selection-section">
              <div className="section-header">
                <span className="section-title">Size</span>
                {selectedSize && <span className="selected-value">Selected: {selectedSize}</span>}
              </div>
              <div className="size-options">
                {currentProduct?.size?.map((size, index) => (
                  <div
                    key={index}
                    className={`size-option ${selectedSize === size ? 'selected' : ''}`}
                    onClick={() => handleSizeSelect(size)}
                  >
                    {size}
                  </div>
                ))}
              </div>
            </div>

            {/* Quantity Selection */}
            <div className="selection-section">
              <div className="section-header">
                <span className="section-title">Quantity</span>
              </div>
              <div className="quantity-selector">
                <button className="quantity-btn" onClick={decrementQuantity} disabled={quantity <= 1}>-</button>
                <span className="quantity-value">{quantity}</span>
                <button className="quantity-btn" onClick={incrementQuantity} disabled={quantity >= 10}>+</button>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="action-buttons">
              <Button
                className="add-to-cart-btn"
                onClick={handleAddToCart}
                loading={loadings}
                icon={<ShoppingCartOutlined />}
                size="large"
              >
                Add to Cart
              </Button>
              <Button
                className="buy-now-btn"
                onClick={handleBuyNow}
                loading={loadings}
                icon={<ThunderboltOutlined />}
                size="large"
              >
                Buy Now
              </Button>
            </div>

            {/* Delivery Info */}
            <div className="delivery-section">
              <div className="delivery-header">
                <EnvironmentOutlined />
                <span>Check Delivery Availability</span>
              </div>
              <div className="pincode-input-wrapper">
                <Input
                  placeholder="Enter pincode"
                  value={pincode}
                  onChange={(e) => setPincode(e.target.value)}
                  maxLength={6}
                  type="number"
                  className="pincode-input"
                />
                <Button onClick={handlePincodeCheck} loading={pincodeLoading}>
                  Check
                </Button>
              </div>
              
              {pinCodeData && pinCodeData.length > 0 && (
                <div className="delivery-info">
                  <div className="delivery-detail">
                    <TruckOutlined />
                    <span>Courier: {pinCodeData[1]?.courier_name}</span>
                  </div>
                  <div className="delivery-detail">
                    <ReloadOutlined />
                    <span>Est. Delivery: {pinCodeData[0]?.etd} ({pinCodeData[0]?.etd_hours} hours)</span>
                  </div>
                </div>
              )}

              <div className="shipping-benefits">
                <div className="benefit-item">
                  <img src={Freeshipping} alt="Free Shipping" />
                  <span>Free Shipping</span>
                </div>
                <div className="benefit-item">
                  <img src={Return} alt="Returns" />
                  <span>7 Days Return & Exchange</span>
                </div>
              </div>
            </div>
          </div>
        </div>
       
      </div>

      {/* Pincode Modal for Mobile */}
      <Modal
        title="Check Delivery"
        open={isPincodeModalVisible}
        onCancel={() => setIsPincodeModalVisible(false)}
        footer={null}
        className="pincode-modal"
      >
        <div className="modal-pincode-input">
          <Input
            placeholder="Enter pincode"
            value={pincode}
            onChange={(e) => setPincode(e.target.value)}
            maxLength={6}
            type="number"
          />
          <Button type="primary" onClick={handlePincodeCheck} loading={pincodeLoading}>
            Check
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default ProductView;